$mol_svg_rect $mol_svg
	dom_name \rect
	pos /
	attr *
		^
		width <= width \0
		height <= height \0
		x <= pos_x \
		y <= pos_y \
